import(/* webpackMode: "eager" */ "/monorepo/dojo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/monorepo/dojo/src/components/cookie-consent-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePreferencesButton"] */ "/monorepo/dojo/src/components/cookie-preferences-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppChrome"] */ "/monorepo/dojo/src/components/layout/app-chrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/monorepo/dojo/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/monorepo/dojo/src/components/layout/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/monorepo/dojo/src/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TransitionProvider"] */ "/monorepo/dojo/src/components/transitions/transition-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionWatcher"] */ "/monorepo/dojo/src/components/version-watcher.tsx");
;
import(/* webpackMode: "eager" */ "/monorepo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Space_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-space-grotesk\",\"display\":\"swap\"}],\"variableName\":\"spaceGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/monorepo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"],\"variable\":\"--font-jetbrains-mono\",\"display\":\"swap\"}],\"variableName\":\"jetbrainsMono\"}");
